import apiSlice from "./apiSlice";

const keyBOQSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        
        // Get All BOQ
        getAllBOQ: builder.query({
            query: (params) => ({
                url: `BOQ`,
                params
            }),
            providesTags: ["Get-All-BOQ"],
            refetchOnMountOrArgChange: true,
        }),
         editBoqList: builder.mutation({
            query: (data)=> ({
                url: `boq`,   
                method: "PUT",
                body: data
            })
        }),
         getAllSubmitBOQ: builder.query({
            query: (params) => ({
                url: `boq/GetWorkFlows`,
                params
            }),
            // providesTags: ["Get-All-BOQ"],
            // refetchOnMountOrArgChange: true,
        }),

    }),
});

export default keyBOQSlice;

export const {
    useGetAllBOQQuery,
    useEditBoqListMutation,
    useGetAllSubmitBOQQuery
} = keyBOQSlice;